import React from 'react';

import { AccountInfoT, isLineOfCredit } from '@consumer-frontend/nc-utils';

import { InstallmentNav } from './InstallmentNav';
import { LocNav } from './LocNav';

export type NavSelectionPropsT = {
  accountInfo?: AccountInfoT;
};

export type NavSelectionT = React.FC<NavSelectionPropsT>;

export const NavSelection: NavSelectionT = ({ accountInfo }) => {
  const { loanType: product } = accountInfo || {};

  const showInstallmentContract = !!product;

  if (accountInfo && isLineOfCredit(product) && accountInfo.loanNumber) {
    return <LocNav
      accountId={accountInfo.accountId}
      openLoanNumber={accountInfo.loanNumber}
      showFeeSaverStatus={accountInfo.showFeeSaverStatus}
    />;
  }

  return <InstallmentNav
    showContract={showInstallmentContract}
  />;
};
